import * as React from 'react';

import { Link } from 'gatsby';

import { styled } from '@mui/material';

import { NavigationLinks } from '@mewa/types';
import {
  ASPECT_RATIO_LANDSCAPE,
  OverviewSlider,
  useSliderViewport,
} from '@mewa/ui';

import {
  clothingCardImages,
  nonClothingCardImages,
} from '../../helpers/image-factory';
import {
  CardAssets,
  HeaderAndFooterTranslations,
  ServiceSegmentLink,
} from '../header/types';
import Image from '../image';

type AllCategoriesSlidersType = {
  clothingServiceSegments: (ServiceSegmentLink & CardAssets)[];
  nonClothingServiceSegments: (ServiceSegmentLink & CardAssets)[];
  langPrefix: string;
  headerAndFooterTranslations: HeaderAndFooterTranslations;
  navigationLinks: NavigationLinks;
  className?: string;
};

export const AllCategoriesSliders = ({
  clothingServiceSegments,
  nonClothingServiceSegments,
  langPrefix,
  headerAndFooterTranslations,
  navigationLinks,
  className = '',
}: AllCategoriesSlidersType) => {
  const viewport = useSliderViewport();

  const clothingSlides = (clothingServiceSegments || []).map((segment) => ({
    image: (
      <Image
        images={clothingCardImages(segment.assets.default)}
        alt={segment.name}
      />
    ),
    hoverImage: (
      <Image
        images={clothingCardImages(segment.assets.hover)}
        alt={segment.name}
      />
    ),
    wrapperLink: (
      <Link to={`${langPrefix}/${segment.slug}`}>{segment.name}</Link>
    ),
  }));

  const nonClothingSlides = (nonClothingServiceSegments || []).map(
    (segment) => ({
      image: (
        <Image
          images={nonClothingCardImages(segment.assets.default)}
          alt={segment.name}
        />
      ),
      hoverImage: (
        <Image
          images={nonClothingCardImages(segment.assets.hover)}
          alt={segment.name}
        />
      ),
      wrapperLink: (
        <Link to={`${langPrefix}/${segment.slug}`}>{segment.name}</Link>
      ),
    }),
  );

  return (
    <div className={className}>
      {clothingSlides.length > 0 && (
        <SliderWrapper>
          <OverviewSlider
            title={navigationLinks.navigation.clothing.name}
            slides={clothingSlides}
            viewport={viewport}
            headingComponent="h2"
          />
        </SliderWrapper>
      )}

      {nonClothingSlides.length > 0 && (
        <SliderWrapper>
          <OverviewSlider
            title={navigationLinks.navigation.nonClothing.name}
            slides={nonClothingSlides}
            aspectRatio={ASPECT_RATIO_LANDSCAPE}
            viewport={viewport}
            headingComponent="h2"
          />
        </SliderWrapper>
      )}
    </div>
  );
};

const SliderWrapper = styled('div')(({ theme }) => ({
  marginTop: '20px',
  marginBottom: '60px',
}));
